import React from 'react';

const SlidePanel = ({ children, isActive, direction }) => {
  const getTransformClass = () => {
    if (!isActive) {
      return direction === 'right' 
        ? 'translate-x-full' 
        : '-translate-x-full';
    }
    return 'translate-x-0';
  };

  return (
    <div 
      className={`absolute inset-0 w-full h-full transition-transform duration-500 ease-in-out ${getTransformClass()}`}
    >
      {children}
    </div>
  );
};

export default SlidePanel; 